<template>
    <FormSection title="My Notes" :full-height="false" :application-id="application" :popoverContent="popoverContent">
        <template #content>
            <section class="d-flex flex-column px-4 py-2">
                <div class="col-12 offset-lg-1 pt-2 col-lg-10">
                    <label for="patients-care-goals" class="mb-2"></label>
                    <CommentInput
                        id="patients-care-goals"
                        :result="patient.myNotes?.note"
                        v-on:resultUpdatedAppended="resultCareGoalsAppended"
                        v-on:resultUpdated="resultCareGoals"
                        placeholder="Enter Comments"
                        :application="application"
                    />
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script src="./MyNotes.ts"></script>
